export default function LocationSection() {
  return (
    <section id="location" data-testid="location-section" className="py-28 bg-[#ece4d6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-5 px-5 py-2 rounded-full bg-[#b89968]/10 border border-[#b89968]/20">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase gold-accent">Find Us</span>
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-[#0f1d3a] mb-3">
            Our <span className="italic font-normal gold-accent">Location</span>
          </h2>
          <div className="section-gold-line mx-auto mb-6" />
          <p className="text-base leading-relaxed text-[#6a7690] max-w-2xl mx-auto">
            Visit Corpus Juris Law Chambers at Ovungal Bazar, Chavakkad, Thrissur District, Kerala.
          </p>
        </div>

        {/* Map */}
        <div className="rounded-2xl overflow-hidden border border-[#d9cdb4] shadow-xl shadow-[#0f1d3a]/5 map-grayscale">
          <iframe
            data-testid="google-map"
            title="Corpus Juris Law Chambers Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3920.5!2d76.0547!3d10.5847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7ee!2sChavakkad%2C%20Kerala!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
